const API_PREFIX = "/v1/api/";
const DEV_BACKEND_ORIGIN = "http://127.0.0.1:8000";

let isInstalled = false;

function isApiRequest(url: string): boolean {
  return url.startsWith(API_PREFIX) || url.startsWith(`${window.location.origin}${API_PREFIX}`);
}

function toDirectDevApiUrl(url: string): string | null {
  if (window.location.hostname !== "localhost") {
    return null;
  }
  if (url.startsWith(API_PREFIX)) {
    return `${DEV_BACKEND_ORIGIN}${url}`;
  }
  const originPrefix = `${window.location.origin}${API_PREFIX}`;
  if (url.startsWith(originPrefix)) {
    return `${DEV_BACKEND_ORIGIN}${url.slice(window.location.origin.length)}`;
  }
  return null;
}

export function installApiAuthFetch(getToken: () => Promise<string | null>) {
  if (isInstalled) {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const url =
      typeof input === "string" ? input : input instanceof URL ? input.toString() : input.url;

    if (!isApiRequest(url)) {
      return originalFetch(input, init);
    }

    let token: string | null = null;
    try {
      token = await getToken();
    } catch (err) {
      throw err;
    }

    if (!token) {
      const request = new Request(input, init);
      try {
        const response = await originalFetch(request);
        return response;
      } catch (err) {
        const fallbackUrl = toDirectDevApiUrl(url);
        if (fallbackUrl && err instanceof TypeError) {
          try {
            const fallbackResp = await originalFetch(
              new Request(fallbackUrl, {
                method: request.method,
                headers: request.headers,
                body: request.method === "GET" || request.method === "HEAD" ? undefined : await request.clone().arrayBuffer(),
                signal: request.signal,
              })
            );
            return fallbackResp;
          } catch (fallbackErr) {
            // Ignore fallback errors and throw original.
          }
        }
        throw err;
      }
    }

    const request = new Request(input, init);
    const headers = new Headers(request.headers);
    if (!headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    try {
      const response = await originalFetch(new Request(request, { headers }));
      return response;
    } catch (err) {
      const fallbackUrl = toDirectDevApiUrl(url);
      if (fallbackUrl && err instanceof TypeError) {
        try {
          const fallbackResp = await originalFetch(
            new Request(fallbackUrl, {
              method: request.method,
              headers,
              body: request.method === "GET" || request.method === "HEAD" ? undefined : await request.clone().arrayBuffer(),
              signal: request.signal,
            })
          );
          return fallbackResp;
        } catch (fallbackErr) {
          // Ignore fallback errors and throw original.
        }
      }
      throw err;
    }
  };

  isInstalled = true;
}
